<template>
  <div
      v-show="visible && hasValidPosition"
      class="table-dots-overlay"
  >
    <div
        class="table-dot-btn table-dot-btn--col"
        :style="colStyle"
        title="Column options"
        @mousedown.stop.prevent="$emit('col-click', $event)"
    >
      <icon name="horizontal3DotsIcon"/>
    </div>

    <div
        class="table-dot-btn table-dot-btn--row"
        :style="rowStyle"
        title="Row options"
        @mousedown.stop.prevent="$emit('row-click', $event)"
    >
      <icon name="vertical3DotsIcon"/>
    </div>
  </div>
</template>

<script>
export default {
  name:  'TableDotsOverlay',
  props: {
    visible: { type: Boolean, default: false },
    colX:    { type: Number, default: 0 },
    colY:    { type: Number, default: 0 },
    rowX:    { type: Number, default: 0 },
    rowY:    { type: Number, default: 0 },
  },
  computed: {
    hasValidPosition() {
      return (this.colX !== 0 || this.colY !== 0) && (this.rowX !== 0 || this.rowY !== 0);
    },
    colStyle() {
      return {
        position:  'fixed',
        left:      `${this.colX}px`,
        top:       `${this.colY}px`,
        transform: 'translateX(-50%)',
        zIndex:    10000,
      };
    },
    rowStyle() {
      return {
        position:  'fixed',
        left:      `${this.rowX}px`,
        top:       `${this.rowY}px`,
        transform: 'translateY(-50%)',
        zIndex:    10000,
      };
    },
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        this.$nextTick(() => this.mountToBody());
      }
    },
  },
  mounted() {
    this.mountToBody();
  },
  updated() {
    if (this.visible && this.hasValidPosition) {
      this.mountToBody();
    }
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  },
  methods: {
    mountToBody() {
      if (this.$el && this.$el.parentNode !== document.body) {
        document.body.appendChild(this.$el);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.table-dots-overlay {
  pointer-events: none;
}
.table-dot-btn {
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 15px;
  padding: 0 8px;
  border: 1px solid #e1dfdf;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  user-select: none;
}
.table-dot-btn--row {
  min-width: 15px;
  width: 15px;
  height: 28px;
  padding: 0;
}
</style>
